module.exports = __webpack_public_path__ + "images/emoji/accept.5a0b2c597a32067a3847.png";